import type { ReactNode } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@components/ui/card";

interface VariantCardProps {
  title: string;
  variant: "admin" | "provider";
  children: ReactNode;
  /**
   * Optional className for CardContent (e.g., "space-y-1" for tighter spacing)
   */
  contentClassName?: string;
  /**
   * Optional className for the title (e.g., "text-red-600" for rejection state)
   */
  titleClassName?: string;
}

/**
 * Shared card component that handles layout differences between admin and provider views.
 *
 * Admin: Title inside card header, muted background
 * Provider: Title outside card (white text), card with default background
 */
export const VariantCard = ({ title, variant, children, contentClassName = "", titleClassName = "" }: VariantCardProps) => {
  const isProvider = variant === "provider";

  if (isProvider) {
    return (
      <div className="space-y-4">
        <h4 className={`font-semibold text-white ${titleClassName}`}>{title}</h4>
        <Card>
          <CardContent className={`py-4 ${contentClassName}`}>{children}</CardContent>
        </Card>
      </div>
    );
  }

  return (
    <Card className="border-none bg-muted/50 shadow-none">
      <CardHeader className="pb-2">
        <CardTitle className={`text-base ${titleClassName}`}>{title}</CardTitle>
      </CardHeader>
      <CardContent className={contentClassName}>{children}</CardContent>
    </Card>
  );
};
